import FortesFiscalService from "../../../services/resource/fortesFiscalService";

import { useEffect, useState } from 'react';
import { getComecoAno, getDataSeteDiasAntesFormatado, getHojeFormatado, getMesAtual, getMesPassado, returnDate, ultimoDiaMesPassado } from "../../../utils/formatDate";
import { Loading } from "../../../componentes/loading/loading";
import DropDown from "../../../componentes/dropdown/dropdown";
import Input from "../../../componentes/input/input";
import { toast } from 'react-toastify';
import DashboardConciliacaoSaldos from "./dashboard";
import { intervaloDatas } from "../../../utils/options";
import { TabelaConciliacao } from "./TabelaConciliacao";
import Button from "../../../componentes/button/button";

export default function ConciliacaoDeSaldos() {
  const [dados, setDados] = useState([]);
  const [showDashboard, setShowDashboard] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingExportacao, setLoadingExportacao] = useState(false);
  const [empresas, setEmpresas] = useState([])
  const [codigoEmpresa, setCodigoEmpresa] = useState("0184");
  const [conta, setConta] = useState("40201");
  const [complemento, setComplemento] = useState("");
  const [descricao, setDescricao] = useState("");
  const [centroCusto, setCentroCusto] = useState("");
  const [chave, setChave] = useState("");
  const [estabelecimento, setEstabelecimento] = useState("");
  const [contaReduzida, setContaReduzida] = useState("");
  const [filtro, setFiltro] = useState(false);
  const [dataInicial, setDataInicial] = useState(getMesAtual());
  const [dataFinal, setDataFinal] = useState(getHojeFormatado());
  const [filtrarDashboard, setFiltrarDashboard] = useState(0);
  const [dataSelecionada, setDataSelecionada] = useState(7);
  const service = new FortesFiscalService();
  const FileDownload = require('js-file-download');

  useEffect(() => {
    listarEmpresas();
    //listarConciliacao();
    document.title = "MyDash | Conciliação de Saldos"
  }, []);

  const mudarPeriodoDeDatas = (e) => {
    const valor = e.target.value;
    setDataSelecionada(valor);
    if (valor === 14) {
      setFiltro(true);  // abre o filtro
    } else if (valor === 7) {
      setDataInicial(getMesAtual());
      setDataFinal(getHojeFormatado());
      setFiltro(false);
    } else if (valor === 30) {
      setDataInicial(getMesPassado());
      setDataFinal(ultimoDiaMesPassado());
      setFiltro(false);
    } else if (valor === 365) {
      setDataInicial(getComecoAno());
      setDataFinal(getHojeFormatado());
      setFiltro(false);

    } else {
      setFiltro(false);
      setDataInicial(getDataSeteDiasAntesFormatado(valor));
    }

    atualizarDashboard()
  }

  const listarConciliacao = async () => {
    setLoading(true)
    service.conciliacaoDeSaldos({
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      codigoEmpresa: codigoEmpresa,
      conta: conta,
      complemento: complemento,
      centroCusto: centroCusto,
      descricao: descricao,
      chave: chave
    }).then(response => {
      setDados(response.data);
      if (response.data.length <= 0) toast.warning("Sem registros para o filtro informado!");
    }).catch(error => {
      console.error(error)
      console.error('Erro ao realizar consulta: ', error)
    }).finally(() => {
      setTimeout(() => setLoading(false), 400);
    });
  };

  const exportConciliacao = () => {
    setLoadingExportacao(true)
    service.exportConciliacaoDeSaldos({
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      codigoEmpresa: codigoEmpresa,
      conta: conta,
    }).then(response => {
      const date = new Date();
      FileDownload(response.data, "Conciliação de Saldos " + date.getTime() + ".xlsx");
      setTimeout(() => setLoadingExportacao(false), 400);
    }).catch(error => {
      console.error(error)
      console.error(error.message);
      setTimeout(() => setLoadingExportacao(false), 400);
    })
  }

  const listarEmpresas = () => {
    service.buscarEmpresas()
      .then(response => setEmpresas(response.data))
      .catch(error => console.error(error));
  }

  const alteraVisao = () => {
    if (showDashboard) {
      listarConciliacao()
    } else {
    }
    setShowDashboard(!showDashboard)
  }

  const atualizarDashboard = () => {
    var soma = filtrarDashboard + 1;
    setFiltrarDashboard(soma)
  }

  const dadosFiltrados = dados.filter(item => {
    return (
      (conta === "" || item.conta?.toString().includes(conta)) &&
      (complemento === "" || item.complemento?.toLowerCase().includes(complemento.toLowerCase())) &&
      (centroCusto === "" || item.centroCusto?.toString().includes(centroCusto)) &&
      (estabelecimento === "" || item.filial?.toString().includes(estabelecimento)) &&
      (contaReduzida === "" || item.reduzido?.toString().includes(contaReduzida)) &&
      (chave === "" || item.sequencial?.toString().includes(chave)) &&
      (descricao === "" || item.contaNome?.toLowerCase().includes(descricao.toLowerCase()))
    );
  });

  return (
    <div className="w-full p-6">
      <div className="bg-card border border-border rounded-lg shadow-card p-4 mb-6">
        <div className="flex flex-wrap items-end gap-3 justify-between">
          <div className="flex flex-wrap items-end gap-3 flex-1 min-w-[280px]">
            <div className="w-full sm:w-60">
              <DropDown
                optional
                options={intervaloDatas}
                label="Período"
                optionLabel="label"
                optionValue="value"
                filter={false}
                value={dataSelecionada}
                onChange={mudarPeriodoDeDatas}
              />
            </div>

            {filtro && (
              <div className="w-full sm:w-44">
                <Input
                  label="Data Inicial"
                  type="date"
                  onChange={(e) => setDataInicial(e.target.value)}
                  className="h-10 px-0 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary w-full"
                  value={dataInicial}
                />
              </div>
            )}

            {filtro && (
              <div className="w-full sm:w-44">
                <Input
                  label="Data Final"
                  type="date"
                  className="h-10 px-0 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary w-full"
                  onChange={(e) => setDataFinal(e.target.value)}
                  value={dataFinal}
                />
              </div>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-3 items-end justify-end flex-none">
            <div className="sm:w-56 w-full">
              <Input
                type="text"
                onBlur={atualizarDashboard}
                onChange={(e) => setConta(e.target.value)}
                classNameIcon="text-muted-foreground"
                value={conta}
                label="Conta Inicial"
                className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary w-full"
              />
            </div>

            <div className="flex gap-3">
              <Button
                onClick={alteraVisao}
                iconLeft={showDashboard ? "fas fa-list" : "fas fa-pie-chart"}
                title={showDashboard ? "Exibir Lista" : "Exibir Dashboard"}
                label={showDashboard ? "Exibir Lista" : "Exibir Dashboard"}
                disabled={loading}
              />
              <Button
                onClick={exportConciliacao}
                variant="green"
                iconLeft="fas fa-file-excel"
                title="Exportar Planilha"
                label="Exportar Planilha"
                loading={loadingExportacao}
                disabled={loadingExportacao || loading}
              />
            </div>
          </div>
        </div>
      </div>
      {showDashboard ?
        <DashboardConciliacaoSaldos
          dataInicial={dataInicial}
          dataFinal={dataFinal}
          codigoEmpresa={codigoEmpresa}
          conta={conta}
          filtrar={filtrarDashboard}
          setLoad={loading} />
        :
        <div className="bg-card border border-border rounded-xl shadow-soft overflow mb-4 fade-in">
          <div className="p-6 border-b border-border">
            <div className="flex items-center">
              <div className="bg-primary/10 p-3 rounded-lg mr-4">
                <i className="fas fa-balance-scale text-primary text-xl"></i>
              </div>
              <div>
                <h2 className="text-xl font-display font-bold text-foreground">Conciliação de Saldos</h2>
                <p className="text-muted-foreground">Relatório detalhado de conciliação de saldos contábeis</p>
              </div>
            </div>
          </div>
          <div className="pt-4 pb-6">
            <div className="flex flex-wrap">
              <form className="col-12 col-md-10 p-0" onSubmit={listarConciliacao}>
                <div className="flex flex-wrap mb-1 ">
                  <div className="col-md-3">
                    <DropDown optional label="Empresa"
                      options={empresas}
                      optionLabel="CODIGO"
                      optionLabel2="NOME"
                      optionValue="CODIGO"
                      value={codigoEmpresa}
                      disabled={loading}
                      onChange={e => setCodigoEmpresa(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <Input label="Estabelecimento" type="number" onChange={e => setEstabelecimento(e.target.value)} value={estabelecimento} className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary" />
                  </div>
                  <div className="col-md-2">
                    <Input label="Conta Reduzida" type="number" onChange={e => setContaReduzida(e.target.value)} value={contaReduzida} className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary" />
                  </div>
                  <div className="col-md-2">
                    <Input label="Centro de Custo" type="number" onChange={e => setCentroCusto(e.target.value)} value={centroCusto} className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary" />
                  </div>
                  <div className="col-md-2">
                    <Input label="Histórico" type="text" onChange={e => setComplemento(e.target.value)} value={complemento} className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary" />
                  </div>
                  <div className="col-md-1 flex items-end">
                    <Button loading={loading} type="button" label="Buscar" variant="indigo" iconLeft="fa fa-search" onClick={listarConciliacao} />
                  </div>

                </div>
              </form>
              <div className="col-12 col-md-2">
                <div className="text-right">
                  <p className="text-sm text-muted-foreground mb-1">Total de registros</p>
                  <p className="text-2xl font-display font-bold text-primary">{loading ? "" : dadosFiltrados.length}</p>
                </div>
              </div>
              <div className="px-6  flex flex-wrap gap-3 mt-2">
              </div>
            </div>
            {loading ?
              <Loading label="Carregando Dados" />
              :
              <>
                <TabelaConciliacao dadosFiltrados={dadosFiltrados} />
              </>
            }
          </div>
        </div>
      }
    </div>
  );
}